/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import Alert from '@mui/material/Alert';
import Icon from '@mui/material/Icon';

export const isInt = (number) => {
  return (number * 1) % 1 === 0;
};

export const numberDisplay = (number, point = 0) => {
  const num = number === undefined ? 0 : number * 1;

  if (point === 0) {
    if (isInt(number)) {
      return num.toFixed(point).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  return num.toFixed(point).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export const moneyDisplay = (number, point = 2, currency = '฿') => {
  const num = number === undefined ? 0 : number * 1;
  return `${currency} ${numberDisplay(num, point)}`;
};

export const dateDisplay = (date, style = 1) => {
  const dt = new Date(date);
  let result;

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  let y = dt.getFullYear();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;
  y = style === 2 ? y - 2000 : y;

  if (y > 0) result = `${d}/${m}/${y}`;
  else result = '';

  return result;
};

export const dateTimeDisplay = (date = new Date(), style = 1) => {
  if (date === null) return '-';

  const dt = new Date(date);

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  let y = dt.getFullYear();
  let h = dt.getHours();
  let i = dt.getMinutes();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;
  h = h < 10 ? `0${h}` : h;
  i = i < 10 ? `0${i}` : i;
  y = style === 2 ? y - 2000 : y;

  if (y > 0) return `${d}/${m}/${y} ${h}:${i}`;
  return '';
};

export const timeDisplay = (date = new Date(), style = 1) => {
  if (date === null) return '-';

  const dt = new Date(date);

  let h = dt.getHours();
  let i = dt.getMinutes();
  let y = dt.getFullYear();

  h = h < 10 ? `0${h}` : h;
  i = i < 10 ? `0${i}` : i;
  y = style === 2 ? y - 2000 : y;

  if (y > 0) return `${h}:${i}`;
  return '';
};

export const dateFormat = (date) => {
  const dt = new Date(date);

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  const y = dt.getFullYear();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;

  return `${y}-${m}-${d}`;
};

export const dateFormatDisplay = (date) => {
  const dt = new Date(date);

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  const y = dt.getFullYear();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;

  return dateDisplay(`${y}-${m}-${d}`);
};

export const dateTimeFormat = (date) => {
  const dt = new Date(date);

  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  const y = dt.getFullYear();
  let h = dt.getHours();
  let i = dt.getMinutes();
  let s = dt.getSeconds();

  d = d < 10 ? `0${d}` : d;
  m = m < 10 ? `0${m}` : m;
  h = h < 10 ? `0${h}` : h;
  i = i < 10 ? `0${i}` : i;
  s = s < 10 ? `0${s}` : s;

  return `${y}-${m}-${d} ${h}:${i}:${s}`;
};

export const timeFormat = (date) => {
  const dt = new Date(date);

  let h = dt.getHours();
  let i = dt.getMinutes();
  let s = dt.getSeconds();

  h = h < 10 ? `0${h}` : h;
  i = i < 10 ? `0${i}` : i;
  s = s < 10 ? `0${s}` : s;

  return `${h}:${i}`;
};

export const timeFormater = (str) => {
  let result;
  let h = 0;
  let m = 0;
  let hh = '';
  let mm = '';
  if (str.length > 5 || str.length < 4) {
    result = '';
  } else if (str.length === 4) {
    h = str.substr(0, 2) * 1;
    m = str.substr(2, 2) * 1;
  } else if (str.length === 5) {
    h = str.substr(0, 2) * 1;
    m = str.substr(3, 2) * 1;
  }
  if (h > 23 || m > 59) {
    result = '';
  } else {
    hh = h < 10 ? `0${h}` : h;
    mm = m < 10 ? `0${m}` : m;
    result = `${hh}:${mm}`;
  }

  return result;
};

export const lpadCode = (inp, size) => {
  const str = `${inp}`;
  return str.padStart(size, '0');
};

export const dateNow = () => {
  return dateFormat(new Date());
};

export const timeNow = () => {
  return timeFormat(new Date());
};

export const dateTimeNow = () => {
  return dateTimeFormat(new Date());
};

export const dateFirstMonth = () => {
  const dt = new Date();

  return dateFormat(new Date(dt.getFullYear(), dt.getMonth(), 1, 0, 0, 0, 0));
};

export const dateTimeFirstMonth = () => {
  const dt = new Date();

  return dateTimeFormat(new Date(dt.getFullYear(), dt.getMonth(), 1, 0, 0, 0, 0));
};

export const dateEndMonth = () => {
  const dt = new Date();
  const ld = new Date(dt.getFullYear(), dt.getMonth() + 1, 0).getDate();

  return dateFormat(new Date(dt.getFullYear(), dt.getMonth(), ld, 0, 0, 0, 0));
};

export const dateTimeEndMonth = () => {
  const dt = new Date();
  const ld = new Date(dt.getFullYear(), dt.getMonth() + 1, 0).getDate();

  return dateTimeFormat(new Date(dt.getFullYear(), dt.getMonth(), ld, 23, 59, 59, 0));
};

export const dateAdd = (day) => {
  const dt = new Date();
  dt.setDate(dt.getDate() + day);

  return dateFormat(new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0, 0));
};

export const dateTimeAdd = (day) => {
  const dt = new Date();
  dt.setDate(dt.getDate() + day);

  return dateTimeFormat(new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0, 0));
};

export const dateTimeEnd = (day) => {
  const dt = new Date();
  dt.setDate(dt.getDate() + day);

  return dateTimeFormat(new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59, 59, 0));
};

export const maskTel = (entry = '') => {
  try {
    const match = entry
      .replace(/\D+/g, '')
      .replace(/^1/, '')
      .match(/([^\d]*\d[^\d]*){1,10}$/)[0];
    const part1 = match.length > 2 ? `(${match.substring(0, 3)})` : match;
    const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : '';
    const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : '';
    return `${part1}${part2}${part3}`;
  } catch (error) {
    return '';
  }
};

export const formatTel = (entry = '') => {
  try {
    return entry
      .replace(/\D+/g, '')
      .replace(/^1/, '')
      .match(/([^\d]*\d[^\d]*){1,10}$/)[0];
  } catch (error) {
    return '';
  }
};

export const maskIdCard = (entry = '') => {
  try {
    const match = entry.replace(/\D+/g, '').match(/([^\d]*\d[^\d]*){1,13}$/)[0];
    const part1 = match.length > 1 ? `${match.substring(0, 1)}` : match;
    const part2 = match.length > 1 ? `-${match.substring(1, 5)}` : '';
    const part3 = match.length > 5 ? `-${match.substring(5, 10)}` : '';
    const part4 = match.length > 10 ? `-${match.substring(10, 12)}` : '';
    const part5 = match.length > 12 ? `-${match.substring(12, 13)}` : '';
    return `${part1}${part2}${part3}${part4}${part5}`;
  } catch (error) {
    return '';
  }
};

export const verifyEmail = (value) => {
  const emailRex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
};

export const verifyLength = (value, length) => {
  if (value.length >= length) {
    return true;
  }
  return false;
};

export const dateDisplayLocale = (date, language = 'th-TH') => {
  return date.toLocaleDateString(language, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export const codeStatus = (label, color = 'info') => {
  return <code className={`color-${color}`}>{label}</code>;
};

export const sizeDisplay = (item) => {
  if (item.color_name === '') {
    if (item.size_name === '') return null;

    return item.size_name;
  }

  if (item.size_name === '')
    return (
      <Chip
        label={item.color_name}
        sx={{ backgroundColor: item.color }}
        variant='outlined'
        size='small'
      />
    );

  return (
    <Chip
      label={item.size_name}
      sx={{ backgroundColor: item.color }}
      variant='outlined'
      size='small'
    />
  );
};

export const imageDisplay = (item) => {
  return <Avatar alt='' src={item.image} variant='rounded' />;
};

export const statusDisplay = (item) => {
  if (item.status_name === undefined) return null;

  const color = item.status_color === 'primary' ? 'error' : item.status_color;

  return (
    <Alert
      icon={<Icon>{item.status_icon}</Icon>}
      severity={color}
      sx={{
        fontSize: '14px',
        padding: '0 10px',
        fontWeight: 400,
        borderRadius: 5,
        whiteSpace: 'nowrap',
      }}
    >
      {item.status_name}
    </Alert>
  );
};

export const statusFaDisplay = (item) => {
  if (item.status_name === undefined) return null;

  const color = item.status_color === 'primary' ? 'error' : item.status_color;

  return (
    <code className={`color-${item.status_color}`}>
      <i className={item.status_icon} /> {item.status_name}
    </code>
  );
};

export const enableDisplay = (inp) => {
  if (inp === 'Y') return <Icon color='info'>verified</Icon>;
  return <Icon color='error'>not_interested</Icon>;
};

export const notifyBrowser = async (notificationText = 'Thank you for enable') => {
  if (!('Notification' in window)) {
    alert('Browser does not support notifications');
  } else if (Notification.permission === 'granted') {
    const notification = new Notification(notificationText);
  } else if (Notification.permission !== 'denined') {
    await Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        const notification = new Notification(notificationText);
      }
    });
  }
};

export const exitApp = () => {
  window.location.replace('/signin');
};
